import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-8" }

import { motion } from "motion-v";

interface SurroundArticle {
  title: string;
  description: string;
  path: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogArticleSurround',
  props: {
    surround: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UCard = _resolveComponent("UCard")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.surround, (article, index) => {
      return (_openBlock(), _createBlock(_unref(motion).div, {
        key: article.path,
        initial: { opacity: 0, y: 20 },
        "while-in-view": { opacity: 1, y: 0 },
        viewport: { once: true, margin: '-50px' },
        transition: { duration: 0.4, delay: index * 0.1, ease: [0.25, 1, 0.5, 1] }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NuxtLink, {
            to: article.path,
            class: "group block h-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UCard, {
                class: "h-full flex flex-col",
                ui: {
            root: 'hover:ring-2 hover:ring-primary-500 dark:hover:ring-primary-400 transition-all duration-300 h-full flex flex-col',
            body: 'flex-1 flex flex-col',
          }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(`flex items-center gap-2 ${index > 0 ? 'justify-end' : 'justify-start'}`)
                  }, [
                    _createVNode(_unref(motion).div, {
                      "while-hover": { x: index === 0 ? -4 : 4 },
                      transition: { type: 'spring', stiffness: 400 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UIcon, {
                          name: index === 0 ? 'i-lucide:arrow-left' : 'i-lucide:arrow-right',
                          class: "w-4 h-4 text-neutral-500 group-hover:text-primary-500 transition-colors"
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1032, ["while-hover"]),
                    _createElementVNode("span", {
                      class: _normalizeClass(`text-xs text-neutral-500 uppercase flex ${index > 0 ? 'text-right' : 'text-left'}`)
                    }, _toDisplayString(index === 0 ? "Previous" : "Next"), 3)
                  ], 2),
                  _createElementVNode("h3", {
                    class: _normalizeClass(`font-semibold text-neutral-900 dark:text-neutral-100 mt-2 line-clamp-2 ${index > 0 ? 'text-right' : 'text-left'}`)
                  }, _toDisplayString(article.title), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass(`text-sm text-neutral-500 mt-1 line-clamp-2 flex-1 ${index > 0 ? 'text-right' : 'text-left'}`)
                  }, _toDisplayString(article.description), 3)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 2
      }, 1032, ["transition"]))
    }), 128))
  ]))
}
}

})